import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { supabase } from './supabase';
import Auth from './Auth';
import './App.css';

const API = 'https://oddsguru.onrender.com';

const ONE_CIKAN_LIGLER = [39, 140, 78, 135, 61, 2, 3, 203];

const LIG_ICONS = {
  'Premier League': '🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'La Liga': '🇪🇸', 'Bundesliga': '🇩🇪',
  'Serie A': '🇮🇹', 'Ligue 1': '🇫🇷', 'Süper Lig': '🇹🇷',
  'UEFA Champions League': '⭐', 'UEFA Europa League': '🟠',
  'Championship': '🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'Eredivisie': '🇳🇱', 'Primeira Liga': '🇵🇹',
  'Major League Soccer': '🇺🇸', 'Liga MX': '🇲🇽', 'NBA': '🏀',
};

const DARK = {
  bg: '#0f0f0f', card: '#1a1a1a', border: '#2a2a2a',
  text: '#e0e0e0', subtext: '#888', nav: '#141414',
  input: '#222', green: '#1D9E75', orange: '#EF9F27', red: '#E24B4A',
};
const LIGHT = {
  bg: '#f5f5f5', card: '#fff', border: '#eee',
  text: '#111', subtext: '#888', nav: '#fff',
  input: '#fff', green: '#1D9E75', orange: '#EF9F27', red: '#E24B4A',
};

const LIG_GRUPLARI = [
  { id: 'tumu', label: '🌍 Tümü' },
  { id: 'ana', label: '⭐ Ana Ligler' },
  { id: 'kupa', label: '🏆 Kupalar' },
  { id: 'ikinci', label: '🥈 2. Ligler' },
  { id: 'basketbol', label: '🏀 Basketbol' },
  { id: 'diger', label: '🌐 Diğer' },
];

const GUN_LABELS = [0, 1, 2].map(i => {
  const d = new Date(Date.now() + i * 86400000);
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' });
});
function App() {
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [activeTab, setActiveTab] = useState('analiz');
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [kupon, setKupon] = useState([]);
  const [kuponAcik, setKuponAcik] = useState(false);
  const [simülasyonMiktar, setSimülasyonMiktar] = useState(100);
  const [sayfa, setSayfa] = useState('maclar');
  const [secilenGrup, setSecilenGrup] = useState('tumu');
  const [secilenGun, setSecilenGun] = useState(0);
  const [olurMuOlur, setOlurMuOlur] = useState(null);
  const [sistemDenenir, setSistemDenenir] = useState(null);
  const [yzKupon, setYzKupon] = useState(null);
  const [yzKuponYukleniyor, setYzKuponYukleniyor] = useState(false);
  const [yzAyarlar, setYzAyarlar] = useState({ minConfidence: 65, matchCount: 4, betType: 'all' });
  const [olurYukleniyor, setOlurYukleniyor] = useState(false);
  const [sistemYukleniyor, setSistemYukleniyor] = useState(false);
  const [dark, setDark] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const freeLimit = 5;
  const guestLimit = 3;
  const T = dark ? DARK : LIGHT;

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user || null);
      setUserLoading(false);
    });
    supabase.auth.onAuthStateChange((_e, session) => setUser(session?.user || null));
  }, []);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/api/matches`)
      .then(res => { setMatches(res.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (sayfa === 'olur-mu-olur' && !olurMuOlur && !olurYukleniyor) olurMuOlurYukle();
  }, [sayfa]);

  useEffect(() => {
    if (sayfa === 'sistemde-denenir' && !sistemDenenir && !sistemYukleniyor) sistemDenenirsYukle();
  }, [sayfa]);

  const cikisYap = async () => { await supabase.auth.signOut(); setUser(null); };
  const isPremium = user?.email === 'basaramadimabi@gmail.com';

  const canOpenMatch = (index) => {
    if (isPremium) return true;
    if (!user) return index < guestLimit;
    return index < freeLimit;
  };

  const openMatch = (match, index) => {
    if (!canOpenMatch(index)) {
      if (!user) setShowAuthModal(true);
      else alert('Bu kart için Premium üyelik gerekiyor!');
      return;
    }
    setActiveTab('analiz');
    setSelectedMatch(match);
  };

  const kuponeEkle = (match, secim, oran) => {
    const parsed = parseFloat(oran);
    if (!oran || isNaN(parsed)) return;
    const varMi = kupon.find(k => k.matchId === match.id);
    if (varMi) setKupon(kupon.map(k => k.matchId === match.id ? { ...k, secim, oran: parsed } : k));
    else setKupon([...kupon, { matchId: match.id, home: match.home, away: match.away, secim, oran: parsed }]);
    setKuponAcik(true);
  };

  const kupondenCikar = (matchId) => setKupon(kupon.filter(k => k.matchId !== matchId));
  const toplamOran = kupon.reduce((acc, k) => acc * k.oran, 1);
  const simülasyonKazanc = (simülasyonMiktar * toplamOran).toFixed(2);

  // Tarih hesaplama
  const getDateForIndex = (i) => {
    const d = new Date();
    d.setDate(d.getDate() + i);
    return d.toISOString().split('T')[0];
  };

  // Filtreleme
  const filteredMatches = matches.filter(m => {
    const gunUygun = m.match_date === getDateForIndex(secilenGun);
    if (!gunUygun) return false;
    if (secilenGrup === 'tumu') return true;
    if (secilenGrup === 'basketbol') return m.sport === 'basketbol';
    if (secilenGrup === 'ana') return m.ligKategori === 'ana';
    if (secilenGrup === 'kupa') return m.ligKategori === 'kupa';
    if (secilenGrup === 'ikinci') return m.ligKategori === 'ikinci';
    if (secilenGrup === 'diger') return m.ligKategori === 'diger' && m.sport === 'futbol';
    return true;
  });

  const oneCikanMaclar = matches.filter(m =>
    m.match_date === getDateForIndex(0) &&
    ONE_CIKAN_LIGLER.includes(m.league_id)
  ).slice(0, 4);

  const getBarColor = (pct) => pct >= 65 ? T.green : pct >= 45 ? T.orange : T.red;

  const FormDot = ({ result }) => {
    const colors = { G: T.green, B: T.orange, M: T.red };
    return <div style={{ width: 8, height: 8, borderRadius: '50%', background: colors[result] || '#555' }}></div>;
  };

  const OranButon = ({ label, value, match, secim }) => {
    if (!value || value === '—' || isNaN(parseFloat(value))) return (
      <div style={{ background: dark ? '#222' : '#f5f5f5', borderRadius: 8, padding: '7px 4px', textAlign: 'center', opacity: 0.35 }}>
        <div style={{ fontSize: 10, color: T.subtext, marginBottom: 2 }}>{label}</div>
        <div style={{ fontSize: 13, color: T.subtext }}>—</div>
      </div>
    );
    const secili = kupon.find(k => k.matchId === match.id && k.secim === secim);
    return (
      <div onClick={() => kuponeEkle(match, secim, value)}
        style={{ background: secili ? (dark ? '#0d3326' : '#E1F5EE') : (dark ? '#222' : '#f5f5f5'), borderRadius: 8, padding: '7px 4px', textAlign: 'center', cursor: 'pointer', border: secili ? `1px solid ${T.green}` : '1px solid transparent' }}>
        <div style={{ fontSize: 10, color: T.subtext, marginBottom: 2 }}>{label}</div>
        <div style={{ fontSize: 13, fontWeight: 500, color: T.green }}>{value}</div>
      </div>
    );
  };

  const yzKuponOlustur = async () => {
    if (!user) { setShowAuthModal(true); return; }
    setYzKuponYukleniyor(true);
    try {
      const res = await axios.post(`${API}/api/generate-coupon`, yzAyarlar);
      setYzKupon(res.data);
    } catch (e) { console.log(e); }
    setYzKuponYukleniyor(false);
  };

  const olurMuOlurYukle = async () => {
    setOlurYukleniyor(true);
    try {
      const res = await axios.get(`${API}/api/olur-mu-olur`);
      setOlurMuOlur(res.data);
    } catch (e) { console.log(e); }
    setOlurYukleniyor(false);
  };

  const sistemDenenirsYukle = async () => {
    setSistemYukleniyor(true);
    try {
      const res = await axios.get(`${API}/api/sistemde-denenir`);
      setSistemDenenir(res.data);
    } catch (e) { console.log(e); }
    setSistemYukleniyor(false);
  };

  const MacKarti = ({ match, index, buyuk = false }) => {
    const acik = canOpenMatch(index);
    return (
      <div style={{ border: `1px solid ${T.border}`, borderRadius: 12, padding: buyuk ? 16 : 14, background: T.card, cursor: 'pointer' }}
        onMouseEnter={e => e.currentTarget.style.borderColor = T.green}
        onMouseLeave={e => e.currentTarget.style.borderColor = T.border}>
        <div onClick={() => openMatch(match, index)}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: T.subtext, marginBottom: 8 }}>
            <span>{LIG_ICONS[match.league] || (match.sport === 'basketbol' ? '🏀' : '⚽')} {match.league}</span>
            <span style={{ fontSize: 10, color: match.match_date === getDateForIndex(0) ? T.green : match.match_date === getDateForIndex(1) ? T.orange : T.subtext }}>
              {match.match_date === getDateForIndex(0) ? 'Bugün' : match.match_date === getDateForIndex(1) ? 'Yarın' : 'Öbür Gün'} {match.match_time}
            </span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: 6, marginBottom: 10 }}>
            <div style={{ fontSize: buyuk ? 14 : 13, fontWeight: 500, textAlign: 'center', color: T.text }}>{match.home}</div>
            <div style={{ fontSize: 11, color: T.subtext }}>vs</div>
            <div style={{ fontSize: buyuk ? 14 : 13, fontWeight: 500, textAlign: 'center', color: T.text }}>{match.away}</div>
          </div>
        </div>
        {match.odds && match.sport === 'futbol' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 8 }}>
            <OranButon label="MS 1" value={match.odds.ms1} match={match} secim="MS 1" />
            <OranButon label="MS X" value={match.odds.msx} match={match} secim="MS X" />
            <OranButon label="MS 2" value={match.odds.ms2} match={match} secim="MS 2" />
          </div>
        )}
        {match.odds && match.sport === 'basketbol' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 8 }}>
            <OranButon label="Ev Kazanır" value={match.odds.ms1} match={match} secim="MS 1" />
            <OranButon label="Dep Kazanır" value={match.odds.ms2} match={match} secim="MS 2" />
          </div>
        )}
        <div onClick={() => openMatch(match, index)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {!acik
            ? <span style={{ fontSize: 11, background: dark ? '#1a1200' : '#FAEEDA', color: T.orange, padding: '2px 8px', borderRadius: 20 }}>
                {!user ? '🔒 Üye ol' : '🔒 Premium'}
              </span>
            : <span style={{ fontSize: 11, background: dark ? '#0d3326' : '#E1F5EE', color: T.green, padding: '2px 8px', borderRadius: 20 }}>YZ Analiz</span>}
          {match.top_pick && <span style={{ fontSize: 11, color: T.green, fontWeight: 500 }}>{match.top_pick.split('—')[0]}</span>}
        </div>
      </div>
    );
  };

  const AuthModal = () => (
    <div onClick={(e) => { if (e.target === e.currentTarget) setShowAuthModal(false); }}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 20 }}>
      <div style={{ background: dark ? '#1a1a1a' : '#fff', borderRadius: 16, padding: 28, maxWidth: 360, width: '100%', border: `1px solid ${T.border}` }}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ width: 12, height: 12, borderRadius: '50%', background: T.green, margin: '0 auto 12px' }}></div>
          <div style={{ fontSize: 18, fontWeight: 500, color: T.text, marginBottom: 8 }}>OddsGuru'ya Hoş Geldin!</div>
          <div style={{ fontSize: 13, color: T.subtext }}>Ücretsiz üye ol, yapay zeka analizlerine eriş</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
          {['YZ destekli maç analizleri', 'Piyasa referans oranları', 'Kupon simülatörü', 'Günlük skor tahminleri', 'NBA maçları'].map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: T.text }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: T.green, flexShrink: 0 }}></div>{f}
            </div>
          ))}
        </div>
        <button onClick={() => { setShowAuthModal(false); setSayfa('auth'); }}
          style={{ width: '100%', padding: '11px 0', background: T.green, color: '#fff', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginBottom: 8 }}>
          Ücretsiz Üye Ol
        </button>
        <button onClick={() => { setShowAuthModal(false); setSayfa('auth'); }}
          style={{ width: '100%', padding: '11px 0', background: 'transparent', color: T.subtext, border: `1px solid ${T.border}`, borderRadius: 10, fontSize: 14, cursor: 'pointer' }}>
          Giriş Yap
        </button>
        <button onClick={() => setShowAuthModal(false)}
          style={{ width: '100%', padding: '8px 0', background: 'transparent', color: T.subtext, border: 'none', fontSize: 12, cursor: 'pointer', marginTop: 4 }}>
          Kapat
        </button>
      </div>
    </div>
  );

  if (userLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f0f' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#1D9E75', margin: '0 auto 12px' }}></div>
        <p style={{ color: '#888', fontSize: 14 }}>OddsGuru yükleniyor...</p>
      </div>
    </div>
  );

  if (sayfa === 'auth') return <Auth onLogin={(u) => { setUser(u); setSayfa('maclar'); }} />;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, color: T.text, fontFamily: 'sans-serif' }}>
      {showAuthModal && <AuthModal />}
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 20px', borderBottom: `1px solid ${T.border}`, background: T.nav, position: 'sticky', top: 0, zIndex: 100 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 18, fontWeight: 500, color: T.text }}>
            <div style={{ width: 10, height: 10, borderRadius: '50%', background: T.green }}></div>
            OddsGuru
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button onClick={() => setDark(!dark)} style={{ padding: '6px 10px', border: `1px solid ${T.border}`, borderRadius: 8, background: 'transparent', cursor: 'pointer', fontSize: 16 }}>{dark ? '☀️' : '🌙'}</button>
            {kupon.length > 0 && (
              <button onClick={() => setKuponAcik(!kuponAcik)} style={{ padding: '6px 14px', border: 'none', borderRadius: 8, background: T.green, color: '#fff', cursor: 'pointer', fontSize: 13 }}>
                🎟 Kupon ({kupon.length})
              </button>
            )}
            {user ? (
              <>
                <button onClick={cikisYap} style={{ padding: '6px 14px', border: `1px solid ${T.border}`, borderRadius: 8, background: 'transparent', cursor: 'pointer', fontSize: 13, color: T.text }}>Çıkış</button>
                {isPremium
                  ? <span style={{ fontSize: 12, background: dark ? '#0d3326' : '#E1F5EE', color: T.green, padding: '5px 12px', borderRadius: 8 }}>👑 Premium</span>
                  : <button style={{ padding: '6px 14px', border: 'none', borderRadius: 8, background: T.orange, color: '#fff', cursor: 'pointer', fontSize: 13 }}>Premium</button>
                }
              </>
            ) : (
              <>
                <button onClick={() => setSayfa('auth')} style={{ padding: '6px 14px', border: `1px solid ${T.border}`, borderRadius: 8, background: 'transparent', cursor: 'pointer', fontSize: 13, color: T.text }}>Giriş Yap</button>
                <button onClick={() => setSayfa('auth')} style={{ padding: '6px 14px', border: 'none', borderRadius: 8, background: T.green, color: '#fff', cursor: 'pointer', fontSize: 13 }}>Üye Ol</button>
              </>
            )}
          </div>
        </nav>

        <div style={{ display: 'flex', borderBottom: `1px solid ${T.border}`, background: T.nav }}>
          {[
            { id: 'maclar', label: '⚽ Maçlar' },
            { id: 'yz-kupon', label: '🤖 YZ Kupon' },
            { id: 'olur-mu-olur', label: '🎯 Olur mu Olur?' },
            { id: 'sistemde-denenir', label: '🔥 Sistemde Denenir' },
          ].map(tab => (
            <button key={tab.id} onClick={() => setSayfa(tab.id)}
              style={{ flex: 1, padding: '10px 4px', background: 'none', border: 'none', borderBottom: sayfa === tab.id ? `2px solid ${T.green}` : '2px solid transparent', color: sayfa === tab.id ? T.green : T.subtext, fontSize: 11, cursor: 'pointer', fontWeight: sayfa === tab.id ? 500 : 400 }}>
              {tab.label}
            </button>
          ))}
        </div>

        {!user && sayfa === 'maclar' && (
          <div style={{ background: dark ? '#0d1f18' : '#E1F5EE', padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: T.green }}>YZ analizleri ve daha fazlası için <strong>ücretsiz üye ol</strong></span>
            <button onClick={() => setSayfa('auth')} style={{ fontSize: 11, padding: '5px 14px', background: T.green, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer' }}>Üye Ol</button>
          </div>
        )}

        {user && !isPremium && sayfa === 'maclar' && (
          <div style={{ background: dark ? '#1a1200' : '#FAEEDA', padding: '8px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: T.orange }}>Free hesap — ilk <strong>5 maç</strong> kartını açabilirsin</span>
            <button style={{ fontSize: 11, padding: '4px 12px', background: T.orange, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer' }}>Premium'a geç</button>
          </div>
        )}

        {kuponAcik && kupon.length > 0 && (
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, margin: '12px 20px', padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: T.text }}>🎟 Kupon Simülatörü</span>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setKupon([])} style={{ fontSize: 11, color: T.red, background: 'none', border: 'none', cursor: 'pointer' }}>Temizle</button>
                <button onClick={() => setKuponAcik(false)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: T.subtext }}>×</button>
              </div>
            </div>
            {kupon.map((k, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: `1px solid ${T.border}` }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: T.text }}>{k.home} — {k.away}</div>
                  <div style={{ fontSize: 11, color: T.green, marginTop: 2 }}>{k.secim}</div>
                </div>
                <span style={{ fontSize: 13, fontWeight: 500, color: T.green, minWidth: 36, textAlign: 'center' }}>{k.oran}</span>
                <button onClick={() => kupondenCikar(k.matchId)} style={{ background: 'none', border: 'none', color: T.red, cursor: 'pointer', fontSize: 16 }}>×</button>
              </div>
            ))}
            <div style={{ marginTop: 12, padding: '10px 0', borderTop: `1px solid ${T.border}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 12, color: T.subtext }}>Toplam oran:</span>
                <span style={{ fontSize: 14, fontWeight: 500, color: T.text }}>{toplamOran.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <span style={{ fontSize: 12, color: T.subtext }}>Miktar:</span>
                <input type="number" value={simülasyonMiktar} onChange={e => setSimülasyonMiktar(Number(e.target.value))}
                  style={{ width: 80, padding: '5px 8px', border: `1px solid ${T.border}`, borderRadius: 6, fontSize: 13, background: T.input, color: T.text }} />
                <span style={{ fontSize: 12, color: T.subtext }}>₺</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', background: dark ? '#0d3326' : '#E1F5EE', borderRadius: 8, padding: '10px 12px' }}>
                <span style={{ fontSize: 13, color: T.green }}>Simüle kazanç:</span>
                <span style={{ fontSize: 16, fontWeight: 500, color: T.green }}>{simülasyonKazanc} ₺</span>
              </div>
              <p style={{ fontSize: 10, color: T.subtext, marginTop: 8, textAlign: 'center' }}>Bu simülasyon amaçlıdır. Gerçek bahis değildir.</p>
            </div>
          </div>
        )}

        {sayfa === 'maclar' && (
          <div style={{ display: 'flex' }}>
            {/* Sol panel */}
            <div style={{ width: 180, minWidth: 180, borderRight: `1px solid ${T.border}`, padding: '12px 0', background: dark ? '#141414' : '#fafafa', minHeight: '80vh' }}>
              <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '0 14px', marginBottom: 8 }}>Kategoriler</div>
              {LIG_GRUPLARI.map(g => (
                <div key={g.id} onClick={() => setSecilenGrup(g.id)}
                  style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 12, color: secilenGrup === g.id ? T.green : T.subtext, background: secilenGrup === g.id ? (dark ? '#0d3326' : '#E1F5EE') : 'transparent', borderLeft: secilenGrup === g.id ? `3px solid ${T.green}` : '3px solid transparent', fontWeight: secilenGrup === g.id ? 500 : 400 }}>
                  {g.label}
                </div>
              ))}

              <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '12px 14px 6px', marginTop: 8, borderTop: `1px solid ${T.border}` }}>Gün</div>
              {GUN_LABELS.map((gun, i) => (
                <div key={i} onClick={() => setSecilenGun(i)}
                  style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 12, color: secilenGun === i ? T.green : T.subtext, background: secilenGun === i ? (dark ? '#0d3326' : '#E1F5EE') : 'transparent', borderLeft: secilenGun === i ? `3px solid ${T.green}` : '3px solid transparent', fontWeight: secilenGun === i ? 500 : 400 }}>
                  {gun}
                </div>
              ))}
            </div>

            {/* Sağ panel */}
            <div style={{ flex: 1, padding: 16 }}>
              {secilenGrup === 'tumu' && secilenGun === 0 && oneCikanMaclar.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: T.subtext, marginBottom: 10 }}>⭐ Günün Öne Çıkan Maçları</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10 }}>
                    {oneCikanMaclar.map((match, i) => <MacKarti key={match.id} match={match} index={i} buyuk={true} />)}
                  </div>
                  <div style={{ borderTop: `1px solid ${T.border}`, margin: '16px 0' }}></div>
                  <div style={{ fontSize: 12, fontWeight: 500, color: T.subtext, marginBottom: 10 }}>Tüm Maçlar</div>
                </div>
              )}
              {loading ? (
                <div style={{ textAlign: 'center', padding: 40, color: T.subtext }}>Maçlar yükleniyor...</div>
              ) : filteredMatches.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 40, color: T.subtext }}>Bu kategori için maç bulunamadı.</div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10 }}>
                  {filteredMatches.map((match, i) => <MacKarti key={match.id} match={match} index={i} />)}
                </div>
              )}
            </div>
          </div>
        )}

        {sayfa === 'yz-kupon' && (
          <div style={{ padding: 20 }}>
            <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 6, color: T.text }}>🤖 YZ Kupon Oluşturucu</h2>
            <p style={{ fontSize: 13, color: T.subtext, marginBottom: 16 }}>Yapay zeka günün maçlarından senin kriterlerine göre en iyi kuponu oluşturur.</p>
            {!user && (
              <div style={{ background: dark ? '#0d1f18' : '#E1F5EE', borderRadius: 12, padding: 16, marginBottom: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 13, color: T.green, marginBottom: 10 }}>YZ Kupon oluşturmak için üye olman gerekiyor</div>
                <button onClick={() => setSayfa('auth')} style={{ padding: '8px 20px', background: T.green, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Ücretsiz Üye Ol</button>
              </div>
            )}
            <div style={{ background: dark ? '#1a1a1a' : '#f5f5f5', borderRadius: 12, padding: 16, marginBottom: 20 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 14 }}>
                {[
                  { label: 'Min. güven', key: 'minConfidence', options: [{v:45,l:'%45+'},{v:55,l:'%55+'},{v:65,l:'%65+'},{v:70,l:'%70+'}] },
                  { label: 'Maç sayısı', key: 'matchCount', options: [{v:2,l:'2 maç'},{v:3,l:'3 maç'},{v:4,l:'4 maç'},{v:5,l:'5 maç'}] },
                  { label: 'Bahis tipi', key: 'betType', options: [{v:'all',l:'Hepsi'},{v:'MS sonucu',l:'MS'},{v:'gol üst/alt',l:'Gol'},{v:'KG var/yok',l:'KG'}] },
                ].map(({ label, key, options }) => (
                  <div key={key}>
                    <div style={{ fontSize: 11, color: T.subtext, marginBottom: 6 }}>{label}</div>
                    <select value={yzAyarlar[key]} onChange={e => setYzAyarlar({...yzAyarlar, [key]: key === 'betType' ? e.target.value : Number(e.target.value)})}
                      style={{ width: '100%', padding: '8px 10px', border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 13, background: T.input, color: T.text }}>
                      {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                  </div>
                ))}
              </div>
              <button onClick={yzKuponOlustur} disabled={yzKuponYukleniyor}
                style={{ width: '100%', padding: 12, background: T.green, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
                {yzKuponYukleniyor ? '🤖 Oluşturuyor...' : '🤖 Kupon Oluştur'}
              </button>
            </div>
            {yzKupon && (
              <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 14, color: T.green }}>🤖 YZ'nin Önerdiği Kupon</div>
                {yzKupon.selections.map((s, i) => (
                  <div key={i} style={{ padding: '10px 0', borderBottom: `1px solid ${T.border}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: T.text }}>{s.match}</div>
                        <div style={{ fontSize: 11, color: T.green, marginTop: 2 }}>{s.pick}</div>
                        <div style={{ fontSize: 11, color: T.subtext, marginTop: 3 }}>{s.reason}</div>
                      </div>
                      <div style={{ textAlign: 'right', marginLeft: 10 }}>
                        <div style={{ fontSize: 14, fontWeight: 500, color: T.green }}>{s.oran}</div>
                        <div style={{ fontSize: 10, color: T.subtext }}>%{s.confidence}</div>
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{ marginTop: 12, background: dark ? '#0d3326' : '#E1F5EE', borderRadius: 8, padding: '10px 14px', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 13, color: T.green }}>Toplam oran:</span>
                  <span style={{ fontSize: 16, fontWeight: 500, color: T.green }}>{yzKupon.selections.reduce((acc, s) => acc * s.oran, 1).toFixed(2)}</span>
                </div>
                <p style={{ fontSize: 10, color: T.subtext, marginTop: 8, textAlign: 'center' }}>Bu simülasyon amaçlıdır. Gerçek bahis değildir.</p>
              </div>
            )}
          </div>
        )}

        {sayfa === 'olur-mu-olur' && (
          <div style={{ padding: 20 }}>
            <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 6, color: T.text }}>🎯 Olur mu Olur?</h2>
            <p style={{ fontSize: 13, color: T.subtext, marginBottom: 16 }}>YZ'nin günün en iyi skor tahminleri. Her gün güncellenir.</p>
            {olurYukleniyor ? (
              <div style={{ textAlign: 'center', padding: 40, color: T.subtext }}>🎯 YZ tahmin yapıyor...</div>
            ) : olurMuOlur ? (
              <div>
                {olurMuOlur.predictions.map((p, i) => {
                  const kilitli = !user && i >= 2;
                  return (
                    <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: 16, marginBottom: 10, position: 'relative', overflow: 'hidden' }}>
                      {kilitli && (
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: dark ? 'rgba(15,15,15,0.85)' : 'rgba(245,245,245,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 12, zIndex: 2 }}>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 13, color: T.subtext, marginBottom: 8 }}>🔒 Tüm tahminler için üye ol</div>
                            <button onClick={() => setSayfa('auth')} style={{ padding: '6px 16px', background: T.green, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Ücretsiz Üye Ol</button>
                          </div>
                        </div>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 500, color: T.text }}>{p.match}</div>
                          <div style={{ fontSize: 11, color: T.subtext, marginTop: 2 }}>{p.league}</div>
                        </div>
                        <div style={{ textAlign: 'center', background: T.green, color: '#fff', borderRadius: 10, padding: '6px 14px' }}>
                          <div style={{ fontSize: 20, fontWeight: 500 }}>{p.score}</div>
                          <div style={{ fontSize: 10 }}>tahmin</div>
                        </div>
                      </div>
                      <div style={{ background: dark ? '#222' : '#f5f5f5', borderRadius: 8, padding: '8px 12px', display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 12, color: T.text }}>{p.reason}</span>
                        <span style={{ fontSize: 11, color: T.green, fontWeight: 500, marginLeft: 8 }}>%{p.confidence}</span>
                      </div>
                    </div>
                  );
                })}
                <p style={{ fontSize: 10, color: T.subtext, marginTop: 8, textAlign: 'center' }}>Bu tahminler eğlence amaçlıdır. Her gün güncellenir.</p>
              </div>
            ) : null}
          </div>
        )}

        {sayfa === 'sistemde-denenir' && (
          <div style={{ padding: 20 }}>
            <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 6, color: T.text }}>🔥 Sistemde Denenir</h2>
            <p style={{ fontSize: 13, color: T.subtext, marginBottom: 16 }}>YZ'nin günlük İY/MS sistemi. Ortalama oran 3.00+. Her gün güncellenir.</p>
            {sistemYukleniyor ? (
              <div style={{ textAlign: 'center', padding: 40, color: T.subtext }}>🔥 YZ sistem arıyor...</div>
            ) : sistemDenenir ? (
              <div>
                {sistemDenenir.system.map((s, i) => {
                  const kilitli = !user && i >= 2;
                  return (
                    <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: 16, marginBottom: 10, position: 'relative', overflow: 'hidden' }}>
                      {kilitli && (
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: dark ? 'rgba(15,15,15,0.85)' : 'rgba(245,245,245,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 12, zIndex: 2 }}>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 13, color: T.subtext, marginBottom: 8 }}>🔒 Tüm sistem için üye ol</div>
                            <button onClick={() => setSayfa('auth')} style={{ padding: '6px 16px', background: T.green, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Ücretsiz Üye Ol</button>
                          </div>
                        </div>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 500, color: T.text }}>{s.match}</div>
                          <div style={{ fontSize: 11, color: T.subtext, marginTop: 2 }}>{s.league}</div>
                        </div>
                        <div style={{ textAlign: 'center', background: T.red, color: '#fff', borderRadius: 10, padding: '6px 14px' }}>
                          <div style={{ fontSize: 18, fontWeight: 500 }}>{s.iY_ms}</div>
                          <div style={{ fontSize: 10 }}>İY/MS</div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', background: dark ? '#222' : '#f5f5f5', borderRadius: 8, padding: '8px 12px' }}>
                        <span style={{ fontSize: 12, color: T.text, flex: 1 }}>{s.reason}</span>
                        <div style={{ textAlign: 'right', marginLeft: 8 }}>
                          <div style={{ fontSize: 14, fontWeight: 500, color: T.red }}>{s.oran}</div>
                          <div style={{ fontSize: 10, color: T.subtext }}>%{s.confidence}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div style={{ background: dark ? '#2a0a0a' : '#FCEBEB', borderRadius: 8, padding: '10px 14px', display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                  <span style={{ fontSize: 13, color: T.red }}>Toplam oran:</span>
                  <span style={{ fontSize: 16, fontWeight: 500, color: T.red }}>{sistemDenenir.system.reduce((acc, s) => acc * s.oran, 1).toFixed(2)}</span>
                </div>
                <p style={{ fontSize: 10, color: T.subtext, marginTop: 8, textAlign: 'center' }}>Bu simülasyon amaçlıdır. Her gün güncellenir.</p>
              </div>
            ) : null}
          </div>
        )}

        {selectedMatch && (
          <div onClick={(e) => { if (e.target === e.currentTarget) setSelectedMatch(null); }}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 1000, overflowY: 'auto' }}>
            <div style={{ background: T.card, borderRadius: 12, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', border: `1px solid ${T.border}` }}>
              <div style={{ padding: '16px 18px', borderBottom: `1px solid ${T.border}`, display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 500, color: T.text }}>{selectedMatch.home} — {selectedMatch.away}</div>
                  <div style={{ fontSize: 12, color: T.subtext, marginTop: 3 }}>{selectedMatch.league} · {selectedMatch.stadium}</div>
                </div>
                <button onClick={() => setSelectedMatch(null)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: T.subtext }}>×</button>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', padding: '16px 18px', gap: 8, alignItems: 'center', background: dark ? '#111' : '#f9f9f9', borderBottom: `1px solid ${T.border}` }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 15, fontWeight: 500, color: T.text }}>{selectedMatch.home}</div>
                  <div style={{ fontSize: 11, color: T.subtext, marginTop: 3 }}>Ev sahibi</div>
                  <div style={{ display: 'flex', gap: 3, justifyContent: 'center', marginTop: 6 }}>
                    {(selectedMatch.form?.home || []).map((r, i) => <FormDot key={i} result={r} />)}
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 11, color: T.subtext }}>Başlangıç</div>
                  <div style={{ fontSize: 14, fontWeight: 500, marginTop: 2, color: T.text }}>{selectedMatch.match_time}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 15, fontWeight: 500, color: T.text }}>{selectedMatch.away}</div>
                  <div style={{ fontSize: 11, color: T.subtext, marginTop: 3 }}>Deplasman</div>
                  <div style={{ display: 'flex', gap: 3, justifyContent: 'center', marginTop: 6 }}>
                    {(selectedMatch.form?.away || []).map((r, i) => <FormDot key={i} result={r} />)}
                  </div>
                </div>
              </div>

              {selectedMatch.context?.homeStanding && selectedMatch.context?.awayStanding && (
                <div style={{ padding: '12px 18px', borderBottom: `1px solid ${T.border}`, background: dark ? '#111' : '#fafafa' }}>
                  <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Lig Durumu</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    {[{name: selectedMatch.home, standing: selectedMatch.context.homeStanding}, {name: selectedMatch.away, standing: selectedMatch.context.awayStanding}].map((t, i) => (
                      <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, padding: '8px 12px' }}>
                        <div style={{ fontSize: 11, fontWeight: 500, marginBottom: 4, color: T.text }}>{t.name}</div>
                        <div style={{ fontSize: 12, color: T.green, fontWeight: 500 }}>{t.standing.rank}. sıra · {t.standing.points} puan</div>
                        <div style={{ fontSize: 11, color: T.subtext, marginTop: 2 }}>{t.standing.won}G {t.standing.drawn}B {t.standing.lost}M</div>
                      </div>
                    ))}
                  </div>
                  {selectedMatch.context?.motivation && (
                    <div style={{ background: dark ? '#1a1200' : '#FAEEDA', borderRadius: 8, padding: '8px 12px', marginTop: 8, fontSize: 12, color: T.orange }}>
                      ⚡ {selectedMatch.context.motivation}
                    </div>
                  )}
                </div>
              )}

              {selectedMatch.odds && selectedMatch.sport === 'futbol' && (
                <div style={{ padding: '14px 18px', borderBottom: `1px solid ${T.border}` }}>
                  <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Piyasa Referans Oranları</div>
                  {[
                    { label: 'Maç sonucu', items: [['MS 1', selectedMatch.odds.ms1, 'MS 1'], ['MS X', selectedMatch.odds.msx, 'MS X'], ['MS 2', selectedMatch.odds.ms2, 'MS 2']] },
                    { label: 'İlk yarı', items: [['İY 1', selectedMatch.odds.iy1, 'İY 1'], ['İY X', selectedMatch.odds.iyx, 'İY X'], ['İY 2', selectedMatch.odds.iy2, 'İY 2']] },
                    { label: 'Toplam gol', items: [['1.5Ü', selectedMatch.odds.ust15, '1.5 Üst'], ['2.5Ü', selectedMatch.odds.ust25, '2.5 Üst'], ['3.5Ü', selectedMatch.odds.ust35, '3.5 Üst'], ['1.5A', selectedMatch.odds.alt15, '1.5 Alt'], ['2.5A', selectedMatch.odds.alt25, '2.5 Alt'], ['3.5A', selectedMatch.odds.alt35, '3.5 Alt']] },
                    { label: 'KG', items: [['KG Var', selectedMatch.odds.kgvar, 'KG Var'], ['KG Yok', selectedMatch.odds.kgyok, 'KG Yok']] },
                  ].map(({ label, items }) => (
                    <div key={label} style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 11, color: T.subtext, marginBottom: 5 }}>{label}</div>
                      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(items.length, 3)}, 1fr)`, gap: 6 }}>
                        {items.map(([lbl, val, sec]) => <OranButon key={sec} label={lbl} value={val} match={selectedMatch} secim={sec} />)}
                      </div>
                    </div>
                  ))}
                  <p style={{ fontSize: 10, color: T.subtext, textAlign: 'center' }}>Oranlara tıklayarak kupona ekleyebilirsiniz</p>
                </div>
              )}

              {selectedMatch.odds && selectedMatch.sport === 'basketbol' && (
                <div style={{ padding: '14px 18px', borderBottom: `1px solid ${T.border}` }}>
                  <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Oranlar</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                    <OranButon label="Ev Kazanır" value={selectedMatch.odds.ms1} match={selectedMatch} secim="MS 1" />
                    <OranButon label="Dep Kazanır" value={selectedMatch.odds.ms2} match={selectedMatch} secim="MS 2" />
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', borderBottom: `1px solid ${T.border}` }}>
                {['analiz', 'ihtimaller', 'h2h'].map(tab => (
                  <button key={tab} onClick={() => setActiveTab(tab)}
                    style={{ flex: 1, padding: 10, background: 'none', border: 'none', borderBottom: activeTab === tab ? `2px solid ${T.green}` : '2px solid transparent', color: activeTab === tab ? T.green : T.subtext, fontWeight: activeTab === tab ? 500 : 400, fontSize: 12, cursor: 'pointer' }}>
                    {tab === 'analiz' ? 'YZ Analiz' : tab === 'ihtimaller' ? 'İhtimaller' : 'H2H'}
                  </button>
                ))}
              </div>

              {activeTab === 'analiz' && (
                <div style={{ padding: '14px 18px' }}>
                  {selectedMatch.weather?.hasEffect && (
                    <>
                      <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Hava Durumu</div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 8 }}>
                        {[{icon:'🌡️',val:selectedMatch.weather?.temp,lbl:'Sıcaklık'},{icon:'💨',val:selectedMatch.weather?.wind,lbl:'Rüzgar'},{icon:'💧',val:selectedMatch.weather?.humidity,lbl:'Nem'},{icon:'⛅',val:selectedMatch.weather?.condition,lbl:'Durum'}].map((w,i) => (
                          <div key={i} style={{ background: dark ? '#222' : '#f5f5f5', borderRadius: 8, padding: 10, textAlign: 'center' }}>
                            <div style={{ fontSize: 18 }}>{w.icon}</div>
                            <div style={{ fontSize: 12, fontWeight: 500, marginTop: 3, color: T.text }}>{w.val || '—'}</div>
                            <div style={{ fontSize: 10, color: T.subtext, marginTop: 2 }}>{w.lbl}</div>
                          </div>
                        ))}
                      </div>
                      <div style={{ background: dark ? '#0a1a2a' : '#E6F1FB', borderRadius: 8, padding: '8px 12px', marginBottom: 14, fontSize: 11, color: dark ? '#5ba3d9' : '#0C447C' }}>{selectedMatch.weather.effect}</div>
                    </>
                  )}
                  <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Sakatlık & Kadro</div>
                  {(selectedMatch.injuries || []).length === 0 && <p style={{ fontSize: 12, color: T.subtext, marginBottom: 12 }}>Önemli sakatlık bilgisi yok</p>}
                  {(selectedMatch.injuries || []).map((inj, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: `1px solid ${T.border}` }}>
                      <span style={{ fontSize: 13, flex: 1, color: T.text }}>{inj.name}</span>
                      <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 20, background: inj.status === 'out' ? (dark ? '#2a0a0a' : '#FCEBEB') : inj.status === 'doubt' ? (dark ? '#1a1200' : '#FAEEDA') : (dark ? '#0d3326' : '#E1F5EE'), color: inj.status === 'out' ? T.red : inj.status === 'doubt' ? T.orange : T.green }}>
                        {inj.status === 'out' ? 'Yok' : inj.status === 'doubt' ? 'Şüpheli' : 'Döndü'}
                      </span>
                      <span style={{ fontSize: 11, color: T.subtext }}>{inj.reason}</span>
                    </div>
                  ))}
                  <div style={{ fontSize: 10, fontWeight: 500, color: T.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', margin: '14px 0 8px' }}>YZ Analiz</div>
                  {selectedMatch.top_pick && (
                    <div style={{ padding: '10px 14px', border: `1px solid ${T.green}`, borderRadius: 8, marginBottom: 12 }}>
                      <div style={{ fontSize: 11, color: T.subtext, marginBottom: 3 }}>En güvenli senaryo</div>
                      <div style={{ fontSize: 14, fontWeight: 500, color: T.green }}>{selectedMatch.top_pick}</div>
                    </div>
                  )}
                  <div style={{ background: dark ? '#1a1a1a' : '#f5f5f5', borderRadius: 8, padding: '12px 14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
                      <div style={{ width: 8, height: 8, borderRadius: '50%', background: T.green }}></div>
                      <span style={{ fontSize: 12, fontWeight: 500, color: T.text }}>OddsGuru Yapay Zeka Analizi</span>
                    </div>
                    <div style={{ fontSize: 12, color: dark ? '#ccc' : '#555', lineHeight: 1.7 }}>{selectedMatch.ai_comment || 'Analiz yükleniyor...'}</div>
                  </div>
                </div>
              )}

              {activeTab === 'ihtimaller' && (
                <div style={{ padding: '14px 18px' }}>
                  {(selectedMatch.predictions || []).map((p, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                      <span style={{ fontSize: 12, color: T.subtext, flex: 1 }}>{p.label}</span>
                      <div style={{ width: 100, height: 5, background: dark ? '#333' : '#eee', borderRadius: 3 }}>
                        <div style={{ width: `${p.pct}%`, height: '100%', borderRadius: 3, background: getBarColor(p.pct) }}></div>
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 500, minWidth: 32, textAlign: 'right', color: T.text }}>%{p.pct}</span>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 'h2h' && (
                <div style={{ padding: '14px 18px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    {[{val:selectedMatch.h2h?.homeWins,lbl:`${selectedMatch.home} kazandı`},{val:selectedMatch.h2h?.draws,lbl:'Beraberlik'},{val:selectedMatch.h2h?.awayWins,lbl:`${selectedMatch.away} kazandı`},{val:selectedMatch.h2h?.avgGoals,lbl:'Ort. gol'}].map((s,i) => (
                      <div key={i} style={{ background: dark ? '#222' : '#f5f5f5', borderRadius: 8, padding: '10px 12px' }}>
                        <div style={{ fontSize: 18, fontWeight: 500, color: T.text }}>{s.val || '—'}</div>
                        <div style={{ fontSize: 11, color: T.subtext, marginTop: 2 }}>{s.lbl}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;